import { tapFlashError, tapFlashSuccess } from '../../generic/flash-messages';
import api from '../../REST/api';
import { markUiAction } from '../../utils/create-ui-action';

export const addInvoice = invoice => dispatch =>
  dispatch(
    markUiAction({
      type: addInvoice.toString(),
      payload: api
        .addInvoice({
          data: invoice,
        })
        .then(
          tapFlashSuccess(dispatch, 'Invoice successfully created'),
          tapFlashError(dispatch),
        ),
    }),
  );

addInvoice.toString = () => 'invoices/add-invoice';

export const deleteInvoice = id => dispatch =>
  dispatch(
    markUiAction({
      type: deleteInvoice.toString(),
      payload: api
        .destroyInvoice({ id })
        .then(
          tapFlashSuccess(dispatch, 'Invoice successfully deleted'),
          tapFlashError(dispatch),
        ),
      meta: { id },
    }),
  );
deleteInvoice.toString = () => 'invoices/delete-invoice';

export const updateInvoice = (id, patch) => dispatch =>
  dispatch(
    markUiAction({
      type: updateInvoice.toString(),
      payload: api
        .patchInvoice({
          id,
          data: patch,
        })
        .then(
          tapFlashSuccess(dispatch, 'Invoice successfully updated'),
          tapFlashError(dispatch),
        ),
    }),
  );
updateInvoice.toString = () => 'invoices/update-invoice';

export const reloadInvoice = id => dispatch =>
  dispatch(
    markUiAction({
      type: reloadInvoice.toString(),
      payload: api
        .getInvoice({ id })
        .then(result => result, tapFlashError(dispatch)),
    }),
  );
reloadInvoice.toString = () => 'invoices/reload-invoice';

export const sendCancelInvoiceEmail = (id, cancellationReason) => dispatch =>
  dispatch(
    markUiAction({
      type: sendCancelInvoiceEmail.toString(),
      payload: api
        .sendCancelInvoiceEmail(id, { cancellationReason })
        .then(
          tapFlashSuccess(
            dispatch,
            'An email has been sent to accounting requesting to cancel the invoice',
          ),
          tapFlashError(dispatch),
        )
        .then(() => dispatch(reloadInvoice(id))),
    }),
  );
sendCancelInvoiceEmail.toString = () => 'invoices/send-invoice-cancel-email';
